import { F0Button, IconType } from '@factorialco/f0-react'

export interface Props {
  ariaLabel: string
  onClick: () => void
  icon: IconType
}

const ToolbarButton = ({ ariaLabel, onClick, icon }: Props) => {
  return (
    <F0Button
      label={ariaLabel}
      icon={icon}
      onClick={onClick}
      hideLabel
      variant="outline"
      size="sm"
    />
  )
}

export default ToolbarButton
